module.exports = __webpack_public_path__ + "static/Q1Answer3_Exploringnewplaces_KalenEmsley-0ffae310634dcf1ce63e317aa5cf8ca7.jpg";